// components/Productos.js

//---- IMPORTACIONES ----//
import React, { useEffect, useState } from "react";//para manejar estados y efectos
import { useParams, useNavigate } from "react-router-dom"; //para manejar rutas
import { useCart } from './CartContext'; // Contexto del carrito 

//---- COMPONENTE PRINCIPAL ----//
const ProductoPage = () => {
  //-- RUTAS Y NAVEGACIÓN ----//
  const { id } = useParams(); // extrae el ID del producto de la URL para cargar los datos especificos
  const navigate = useNavigate(); // Función para navegar entre rutas
  
  //-- USO DEL CONTEXTO DEL CARRITO ----//
  const { addToCart } = useCart(); // Función para añadir al carrito

  //-- ESTADOS PRINCIPALES que controlan la información del producto, su presentación y comportamiento ----//
  const [data, setData] = useState(null); // almacena los datos del producto
  const [variations, setVariations] = useState([]); // almacena los array de variaciones del producto
  const [loading, setLoading] = useState(true); // indica si los datos están cargando
  const [error, setError] = useState(null); // guarda errores de la api
  const [selectedVariation, setSelectedVariation] = useState(null); // Variación seleccionada
  const [selectedAttributes, setSelectedAttributes] = useState({}); // Atributos seleccionados
  const [mainImage, setMainImage] = useState(''); // URL de la imagen principal
  const [showToast, setShowToast] = useState(false); // Mostrar notificación
  const [toastMessage, setToastMessage] = useState(''); // Mensaje de notificación
  const [quantity, setQuantity] = useState(1); // cantidad de producto a añadir
  const [tieredPricing, setTieredPricing] = useState([]); // array de precios escalonados
  const [hasTieredPricing, setHasTieredPricing] = useState(false); // Indica si hay precios escalonados
  const [debugInfo, setDebugInfo] = useState(''); // Información de depuración
  const [globalTieredPricing, setGlobalTieredPricing] = useState(null); // precios escalonados globales

  // CREDENCIALES API WOOCOMMERCE
  const CONSUMER_KEY = 'ck_10a7f64bb813e5c80da979e6c7aec6d878caa883';
  const CONSUMER_SECRET = 'cs_ca1236282d5689c22bb93e0122c5650937500cee';

  // ====================================================================
  // FUNCIONES DE DETECCIÓN MEJORADAS
  // ====================================================================
 //-- DETECCIÓN DE PRECIOS ESCALONADOS GLOBALES  ----//
  // Busca datos globales de precios escalonados en el producto o sus variaciones
  const findGlobalTieredPricing = () => {
    // Lista de palabras clave
    const tieredKeywords = [
      'tiered', 
      'pricing', 
      'fixed', 
      'percentage', 
      'bulk', 
      'quantity',
      'rules',
      'price_rules',
      'wholesale',
      'volume',
      'discount',
      'tier',
      'prices',
      'wholesale_pricing',
      'quantity_discount'
    ];

    let globalPricing = null; // Almacena datos encontrados

    // Buscar en metadatos del producto
    if (data && data.meta_data) {
      for (const meta of data.meta_data) { // Iterar sobre metadatos
        const key = meta.key.toLowerCase(); // Normalizar claves a minúsculas
        const hasKeyword = tieredKeywords.some(keyword => key.includes(keyword)); // Verificar si la clave contiene alguna palabra clave

        // Si se encuentra una coincidencia y los datos son válidos con validatePricingData, los almacena en product:meta.key
        if (hasKeyword && meta.value && validatePricingData(meta.value)) {
          globalPricing = { data: meta.value, source: `product:${meta.key}` };
          break;
        }
      }
    }

    // Si no se encontró, buscará en variations.meta_data de forma similar y se guardará en variation:ID:meta.key
    if (!globalPricing && variations.length > 0) {
      for (const variation of variations) {
        if (variation.meta_data) {
          for (const meta of variation.meta_data) {
            const key = meta.key.toLowerCase();
            const hasKeyword = tieredKeywords.some(keyword => key.includes(keyword));
            
            if (hasKeyword && meta.value && validatePricingData(meta.value)) {
              globalPricing = { data: meta.value, source: `variation:${variation.id}:${meta.key}` };
              break;
            }
          }
        }
        if (globalPricing) break;
      }
    }
   
    // Se actualiza el estado globalTieredPricing y se retorna el resultado de los datos encontrados o null
    if (globalPricing) {
      setGlobalTieredPricing(globalPricing);
      return globalPricing;
    } else {
      setGlobalTieredPricing(null);
      return null;
    }
  };
//-- DETECCIÓN DE PRECIOS ESCALONADOS ESPECÍFICOS ----//
  // Busca datos de precios escalonados específicos para una variación dada
  const findTieredPricingForVariation = (currentVariation) => {
    // Lista de palabras clave
    const tieredKeywords = [
      'fixed_price_rules',
      'tiered',
      'pricing',
      'fixed',
      'percentage',
      'bulk',
      'quantity',
      'rules',
      'price_rules',
      'wholesale',
      'volume',
      'discount',
      'tier',
      'prices',
      'wholesale_pricing',
      'quantity_discount'
    ];

    let pricingData = null; // Almacena datos encontrados
    let foundIn = ''; // Fuente de los datos encontrados

    // Buscar en metadatos de la variación específica
    if (currentVariation && currentVariation.meta_data) {
      
      // Iterar sobre metadatos
      for (const meta of currentVariation.meta_data) {
        const key = (meta.key || '').toLowerCase(); // Normalizar clave a minúsculas

        const hasKeyword = tieredKeywords.some(keyword => key.includes(keyword)); // Verifica coincidencias con palabras clave

        // Si se encuentra una coincidencia y los datos son válidos con validatePricingData, los almacena en specific_variation:ID:meta.key
        if (hasKeyword && meta.value && validatePricingData(meta.value)) { 
          pricingData = meta.value; // Datos encontrados 
          foundIn = `specific_variation:${currentVariation.id}:${meta.key}`; // Fuente de los datos
          break;
        }
      }
    }

    if (!pricingData && globalTieredPricing) { // Si no se encontró en la variación, usa datos globales si existen y provienen del producto
      const source = globalTieredPricing.source || ''; // Fuente de los datos globales 
      if (String(source).startsWith('product:')) { // Solo usar si vienen del producto
        pricingData = globalTieredPricing.data; // Datos globales
        foundIn = `global:${globalTieredPricing.source}`; // Fuente de los datos globales
      }
    }

    if (pricingData) { // Retornar datos encontrados
      return { data: pricingData, source: foundIn }; // Datos encontrados
    } else {
      return null;
    }
   };

//-- VALIDACIÓN DE DATOS DE PRECIOS ESCALONADOS ----//
   // Valida que los datos de precios escalonados tengan el formato correcto
   const validatePricingData = (data) => { 
    // Validar que los datos no estén vacíos o nulos
    if (!data) { 
      return false;
    }

    // Intentar validar diferentes formatos posibles
    try {
      // Si es un objeto simple con cantidades como claves
      if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
        const entries = Object.entries(data);
        
        if (entries.length >= 1) {
          const validEntries = entries.filter(([qty, price]) => {
            const quantity = parseInt(qty);
            const priceValue = typeof price === 'string' ? parseFloat(price) : price;
            const isValid = !isNaN(quantity) && !isNaN(priceValue) && priceValue > 0;
            return isValid;
          });
          
          const hasValidEntries = validEntries.length > 0;
          return hasValidEntries;
        }
      }
      
      let dataToCheck = data;
      if (typeof data === 'string') {
        if (data.trim() === '' || data === '[]' || data === '{}') {
          return false;
        }
        try {
          dataToCheck = JSON.parse(data);
        } catch {
          // Si no es JSON válido, podría ser un string con formato diferente
          return false;
        }
      }

      // Validar array de objetos con estructura de precios escalonados
      if (Array.isArray(dataToCheck)) {
        // Verificar si es un array de objetos con estructura de precios
        const validItems = dataToCheck.filter(item => {
          if (!item || typeof item !== 'object') return false;
          
          // Diferentes formatos posibles
          const hasQuantity = item.min_qty !== undefined || item.minimum !== undefined || 
                            item.from !== undefined || item.min !== undefined || 
                            item.quantity !== undefined;
          const hasPrice = item.price !== undefined || item.amount !== undefined || 
                          item.sale_price !== undefined || item.fixed_price !== undefined;
          
          if (hasQuantity && hasPrice) {
            const price = item.price || item.amount || item.sale_price || item.fixed_price;
            return price > 0;
          }
          
          // También aceptar objetos que solo tengan precio (para rangos implícitos)
          if (hasPrice && !hasQuantity) {
            const price = item.price || item.amount || item.sale_price || item.fixed_price;
            return price > 0;
          }
          
          return false;
        });
        
        const isValidArray = validItems.length > 0;
        return isValidArray;
      }
      
      return false;
    } catch (error) {
      console.error("Error validando datos de precios:", error);
      return false;
    }
   };

   //-- PROCESAMIENTO DE DATOS DE PRECIOS ESCALONADOS ----//
   // Procesa los datos de precios escalonados y actualiza el estado
   const processTieredPricingData = (pricingData, basePrice) => {
    const processedTiers = []; // Almacena los niveles procesados
    
    try {
      let dataToProcess = pricingData;

      // Si es un objeto con cantidades como claves y precios como valores
      if (typeof pricingData === 'object' && pricingData !== null && !Array.isArray(pricingData)) {
        const entries = Object.entries(pricingData)
          .map(([qty, price]) => [parseInt(qty), parseFloat(price)])
          .filter(([qty, price]) => !isNaN(qty) && !isNaN(price) && price > 0)
          .sort(([a], [b]) => a - b);
        
        if (entries.length > 0) {
          entries.forEach(([minQty, price], index) => {
            let maxQty = 9999;
            
            if (index < entries.length - 1) {
              const nextMinQty = entries[index + 1][0];
              maxQty = nextMinQty - 1;
            }
             
            processedTiers.push({
              min: minQty,
              max: maxQty,
              price: parseFloat(price.toFixed(2))
            });
          });
        }
      }
      else if (typeof pricingData === 'string') {
        try {
          dataToProcess = JSON.parse(pricingData);
        } catch (error) {
          console.error("Error parseando JSON:", error);
          return;
        }
      }
      
      if (Array.isArray(dataToProcess)) {
        dataToProcess.forEach((tier, index) => {
          if (tier && typeof tier === 'object') {
            // Extraer cantidad mínima con múltiples nombres posibles
            const minQty = tier.min_qty || tier.minimum || tier.from || tier.min || tier.quantity || 
                          (index === 0 ? 1 : (processedTiers[index - 1]?.max + 1 || 1));
            
            // Extraer cantidad máxima con múltiples nombres posibles
            const maxQty = tier.max_qty || tier.maximum || tier.to || tier.max || tier.upto || 
                          (index === dataToProcess.length - 1 ? 9999 : null);
            
            // Extraer precio con múltiples nombres posibles
            const price = tier.price || tier.amount || tier.sale_price || tier.fixed_price;
            
            if (price > 0) {
              processedTiers.push({
                min: parseInt(minQty),
                max: maxQty ? parseInt(maxQty) : 9999,
                price: parseFloat(price.toFixed(2))
              });
            }
          }
        });
      }
      
      // Añadir nivel base si es necesario
      if (processedTiers.length > 0 && basePrice > 0) {
        const firstTier = processedTiers[0];
        if (firstTier.min > 1) {
          processedTiers.unshift({
            min: 1,
            max: firstTier.min - 1,
            price: basePrice
          });
        }
      }
      
    } catch (error) {
      console.error("Error procesando datos de precios escalonados:", error);
    }

    // Ordenar y verificar si hay precios escalonados válidos
    processedTiers.sort((a, b) => a.min - b.min);

    // Verificar si realmente hay precios diferentes
    const hasMultipleTiers = processedTiers.length >= 1; // Cambiado a 1 para mostrar incluso con un solo nivel
    const hasDifferentPrices = processedTiers.length > 0 && 
      new Set(processedTiers.map(t => t.price)).size >= 1; // Cambiado a >= 1

    // DEBUG: Mostrar información de depuración
    console.log("Procesado precios escalonados:", {
      processedTiers,
      hasMultipleTiers,
      hasDifferentPrices,
      basePrice,
      pricingData
    });

    if (hasMultipleTiers) {
      setTieredPricing(processedTiers);
      setHasTieredPricing(true);
    } else {
      setHasTieredPricing(false);
      setTieredPricing([]);
    }
   };

   // ====================================================================
   // FUNCIONES AUXILIARES
   // ====================================================================

  const getBasePrice = () => {
    let basePrice = 0;
    
    if (selectedVariation) {
      basePrice = getNumericPrice(selectedVariation.regular_price || selectedVariation.price);
    } else if (data) {
      const priceInfo = getCurrentPrice();
      basePrice = priceInfo ? getNumericPrice(priceInfo.regular_price || priceInfo.price) : 0;
    }
    
    if (basePrice <= 0) {
      basePrice = 0;
    }
    
    return basePrice;
  };

  const getPriceForQuantity = (qty) => {
    if (!hasTieredPricing || tieredPricing.length === 0) {
      const priceInfo = getCurrentPrice();
      const price = priceInfo ? getNumericPrice(priceInfo.price) : getBasePrice();
      return price;
    }
    
    const tier = tieredPricing.find(t => qty >= t.min && qty <= t.max);
    const price = tier ? tier.price : tieredPricing[tieredPricing.length - 1]?.price || getBasePrice();
    return price;
  };

  const formatPrice = (price) => {
    if (!price && price !== 0) return '0,00';
    if (typeof price === 'string' && price.includes(',')) {
      return price.replace('€', '').trim();
    }
    const numericPrice = parseFloat(price);
    return isNaN(numericPrice) ? '0,00' : numericPrice.toFixed(2).replace('.', ',');
  };

  const getNumericPrice = (price) => {
    if (!price && price !== 0) return 0;
    if (typeof price === 'string' && price.includes(',')) {
      return parseFloat(price.replace('.', '').replace(',', '.'));
    }
    return parseFloat(price);
  };

  const getCurrentPrice = () => {
    try {
      if (data.type === 'variable' && selectedVariation) {
        const regularPrice = getNumericPrice(selectedVariation.regular_price);
        const salePrice = selectedVariation.sale_price ? getNumericPrice(selectedVariation.sale_price) : null;
        const currentPrice = salePrice || regularPrice;
        return {
          price: currentPrice,
          sale_price: salePrice,
          regular_price: regularPrice,
          isOnSale: salePrice && salePrice !== regularPrice
        };
      } else if (data.type === 'simple') {
        const regularPrice = getNumericPrice(data.regular_price);
        const salePrice = data.sale_price ? getNumericPrice(data.sale_price) : null;
        const currentPrice = salePrice || regularPrice;
        return {
          price: currentPrice,
          sale_price: salePrice,
          regular_price: regularPrice,
          isOnSale: salePrice && salePrice !== regularPrice
        };
      }
    } catch (error) {
      console.error('Error al obtener precio:', error);
    }
    return null;
  };

  const showNotification = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 4000);
  };

  // ====================================================================
  // EFFECTS PRINCIPALES MEJORADOS
  // ====================================================================

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        if (!id) throw new Error("No se proporcionó ID de producto");

        const PRODUCT_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products/${id}?consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;

        const productResponse = await fetch(PRODUCT_URL);
        if (!productResponse.ok) throw new Error(`Error HTTP: ${productResponse.status}`);

        const product = await productResponse.json();
        setData(product);

        if (product.images?.[0]) setMainImage(product.images[0].src);

        if (product.type === 'variable') {
          let allVariations = [];
          let page = 1;
          let hasMore = true;
          const perPage = 100;

          while (hasMore) {
            const VARIATIONS_URL = `https://demo.iconestudio.es/wp-json/wc/v3/products/${product.id}/variations?per_page=${perPage}&page=${page}&consumer_key=${CONSUMER_KEY}&consumer_secret=${CONSUMER_SECRET}`;

            const variationsResponse = await fetch(VARIATIONS_URL);

            if (variationsResponse.ok) {
              const variationsData = await variationsResponse.json();
              allVariations = [...allVariations, ...variationsData];

              if (variationsData.length < perPage) {
                hasMore = false;
              } else {
                page++;
              }
            } else {
              hasMore = false;
            }
          }

          setVariations(allVariations);

          const initialAttributes = {};
          product.attributes?.forEach(attr => {
            if (attr.variation) initialAttributes[attr.name] = '';
          });
          setSelectedAttributes(initialAttributes);
        }
      } catch (err) {
        setError(err.message);
        console.error("Error cargando producto:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProductData();
  }, [id]);

  useEffect(() => {
    if (data && variations.length > 0) {
      findGlobalTieredPricing();
    }
  }, [data, variations]);

  useEffect(() => {
    if (selectedVariation) {
      const tieredPricingResult = findTieredPricingForVariation(selectedVariation);
      const basePrice = getBasePrice();
      
      console.log("Datos de precios encontrados:", {
        selectedVariation: selectedVariation.id,
        tieredPricingResult,
        basePrice
      });

      if (tieredPricingResult && basePrice > 0) {
        processTieredPricingData(tieredPricingResult.data, basePrice);
      } else {
        setHasTieredPricing(false);
        setTieredPricing([]);
      }
    } else {
      setHasTieredPricing(false);
      setTieredPricing([]);
    }
  }, [selectedVariation]);

  // ====================================================================
  // MANEJADORES DE EVENTOS
  // ====================================================================

  const handleAttributeChange = (attributeName, value) => {
    const newAttributes = { ...selectedAttributes, [attributeName]: value };
    setSelectedAttributes(newAttributes);
    findMatchingVariation(newAttributes);
  };

  const findMatchingVariation = (attributes) => {
    const allAttributesSelected = Object.values(attributes).every(value => value !== '');
    if (allAttributesSelected) {
      const matchingVariation = variations.find(variation =>
        variation.attributes.every(attr => attributes[attr.name] === attr.option)
      );
      setSelectedVariation(matchingVariation || null);
      if (matchingVariation?.image?.src) {
        setMainImage(matchingVariation.image.src);
      }
    } else {
      setSelectedVariation(null);
      if (data.images?.[0]) setMainImage(data.images[0].src);
    }
  };

  const getAvailableOptions = (attributeName) => {
    const attribute = data?.attributes?.find(attr => attr.name === attributeName);
    return attribute ? attribute.options : [];
  };

  const handleQuantityChange = (e) => {
    const newQuantity = parseInt(e.target.value);
    if (newQuantity > 0) setQuantity(newQuantity);
  };

  const handleAddToCart = () => {
    if (data.type === 'variable' && !selectedVariation) {
      showNotification('Por favor, selecciona todas las opciones antes de añadir al carrito');
      return;
    }

    let productToAdd;
    const unitPrice = getPriceForQuantity(quantity);
    
    if (data.type === 'variable' && selectedVariation) {
      productToAdd = {
        id: selectedVariation.id,
        parent_id: data.id,
        name: data.name,
        price: unitPrice,
        sale_price: selectedVariation.sale_price ? getNumericPrice(selectedVariation.sale_price) : null,
        regular_price: getNumericPrice(selectedVariation.regular_price),
        image: selectedVariation.image?.src || data.images?.[0]?.src,
        quantity: quantity,
        stock_status: selectedVariation.stock_status,
        categories: data.categories || [],
        type: 'variation',
        attributes: selectedVariation.attributes || [],
        product_name: data.name,
        has_tiered_pricing: hasTieredPricing,
        tiered_pricing_data: tieredPricing
      };
    } else if (data.type === 'simple') {
      productToAdd = {
        id: data.id,
        name: data.name,
        price: unitPrice,
        sale_price: data.sale_price ? getNumericPrice(data.sale_price) : null,
        regular_price: getNumericPrice(data.regular_price),
        image: data.images?.[0]?.src,
        quantity: quantity,
        stock_status: data.stock_status,
        categories: data.categories || [],
        type: 'simple',
        attributes: [],
        has_tiered_pricing: hasTieredPricing,
        tiered_pricing_data: tieredPricing
      };
    }

    addToCart(productToAdd);
    
    let message = `Se añadió "${data.name}" al carrito\nCantidad: ${quantity}\nPrecio unitario: ${formatPrice(unitPrice)} €`;
    if (selectedVariation?.attributes) {
      message = `Se añadió "${data.name}" al carrito\n${selectedVariation.attributes.map(attr => `${attr.name}: ${attr.option}`).join(', ')}\nCantidad: ${quantity}\nPrecio unitario: ${formatPrice(unitPrice)} €`;
    }
    
    showNotification(message);
  };

  const canAddToCart = () => {
    if (data.type === 'variable') {
      return selectedVariation !== null;
    }
    return true;
  };

  const getVariableAttributes = () => {
    return data?.attributes?.filter(attr => attr.variation) || [];
  };

  const handleBuy = () => {
    handleAddToCart();
    navigate('/checkout');
  };

  // ====================================================================
  // COMPONENTES INTERNOS
  // ====================================================================

  const TieredPricingTable = () => {
    // Mostrar tabla incluso si solo hay un nivel, para consistencia con WordPress
    const shouldShowTable = hasTieredPricing && tieredPricing.length >= 1;

    if (!shouldShowTable) {
      return null;
    }

    return (
      <table className="tiered-pricing-table">
        <thead>
          <tr className="table-header-row">
            <th className="table-header-quantity">Cantidad</th>
            <th className="table-header-price">Precio unidad</th>
          </tr>
        </thead>
        <tbody>
          {tieredPricing.map((tier, index) => (
            <tr 
              key={index}
              className={`tiered-pricing-row ${quantity >= tier.min && quantity <= tier.max ? 'active-tier' : ''}`}
            >
              <td className="quantity-cell">
                {tier.min === tier.max ?
                  `${tier.min} unidad${tier.min > 1 ? 'es' : ''}` :
                  tier.max === 9999 ?
                    `${tier.min}+ unidades` :
                    `${tier.min} - ${tier.max} unidades`}
              </td>
              <td className="price-cell">
                {formatPrice(tier.price)} €
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  // ====================================================================
  // RENDER PRINCIPAL
  // ====================================================================

  if (loading) return (
    <div className="loading-container">
      <div className="loading-icon">🔄</div>
      <h2 className="loading-title">Cargando producto...</h2>
    </div>
  );

  if (error) return (
    <div className="error-container">
      <div className="error-icon">❌</div>
      <h2 className="error-title">Error al cargar el producto</h2>
      <div className="error-content">
        <p className="error-message"><strong>{error}</strong></p>
        <button onClick={() => navigate('/tienda')} className="error-button">
          Volver a la tienda
        </button>
      </div>
    </div>
  );

  const priceInfo = getCurrentPrice();
  const variableAttributes = getVariableAttributes();
  const currentPrice = getPriceForQuantity(quantity);

  return (
    <div className="product-page-container">
      <button onClick={() => navigate('/tienda')} className="back-button">
        ← Volver a la tienda
      </button>

      <div className="main-container">
        <div className="product-layout">
          <div className="product-info">
            <div className="product-header">
              <h1 className="product-title">{data.name}</h1>
              {data.categories && data.categories.length > 0 && (
                <div className="categories">
                  <h2 className="category-title">
                    {data.categories.map(category => category.name).join(', ')}
                  </h2>
                </div>
              )}
            </div>

            {data.description && (
              <div className="long-description-section">
                <div 
                  dangerouslySetInnerHTML={{ __html: data.description }}
                  className="long-description"
                />
              </div>
            )}

            <div className="purchase-options-section">
              {variableAttributes.length > 0 && (
                <div className="inline-attributes-section">
                  <div className="attributes-row">
                    {variableAttributes.map((attribute, index) => (
                      <div key={index} className="attribute-column">
                        <label className="attribute-label">
                          {attribute.name}:
                        </label>
                        <select 
                          value={selectedAttributes[attribute.name] || ''}
                          onChange={(e) => handleAttributeChange(attribute.name, e.target.value)}
                          className="attribute-select"
                        >
                          <option value="">Selecciona {attribute.name.toLowerCase()}</option>
                          {getAvailableOptions(attribute.name).map((option, optIndex) => (
                            <option key={optIndex} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="inline-purchase-section">
                <div className="price-quantity-container">
                  <div className="quantity-price-group">
                    <div className="quantity-section">
                      <label className="quantity-label">Cantidad:</label>
                      <input  
                        type="number"   
                        value={quantity}
                        onChange={handleQuantityChange}
                        min="1"
                        className="quantity-input-simple"
                      /> 
                    </div>

                    <div className="price-section">
                      <div className="price-container">
                        <span className="current-price">
                          {formatPrice(currentPrice)} € 
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="action-buttons-container">
                  <div className="tax-shipping-info">
                    impuestos no incluidos envió gratis en península
                  </div> 

                  <div className="action-buttons">
                    <button   
                      onClick={handleAddToCart}   
                      disabled={!canAddToCart()}  
                      className="add-to-cart-btn"   
                    >
                      Añadir
                    </button>
                    <button 
                      onClick={handleBuy} 
                      disabled={!canAddToCart()}
                      className="add-to-cart-btn"
                    >
                      Comprar
                    </button>
                  </div>
                </div>
              </div>

              <div className="pricing-and-contact-section">
                <div className="contact-form-section">
                  <h3>¿No encuentras lo que buscas?</h3>
                  <textarea placeholder="CUENTANOS TU PROYECTO" className="project-textarea" />
                  <input type="text" placeholder="NOMBRE" className="input-field" />
                  <input type="tel" placeholder="TELÉFONO" className="input-field" />
                  <input type="email" placeholder="CORREO" className="input-field" />
                  <button className="send-button">enviar</button>
                </div>
                <TieredPricingTable />
              </div>
            </div>
          </div>

          <div className="product-media">
            <div className="image-section">
              {mainImage ? (
                <>
                  <img 
                    src={mainImage}
                    alt={data.name}
                    className="main-image"
                  />
                  {data.images && data.images.length > 1 && (
                    <div className="image-thumbnails">
                      {data.images.map((image, index) => (
                        <img 
                          key={index}
                          src={image.src}
                          alt={image.alt || `Imagen ${index + 1}`}
                          className={`thumbnail ${mainImage === image.src ? 'active' : ''}`}
                          onClick={() => setMainImage(image.src)}
                        /> 
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="image-placeholder">
                  🖼️
                </div> 
              )}
            </div>

            <div className="short-description-section">
              {data.short_description ? (
                <div 
                  dangerouslySetInnerHTML={{ __html: data.short_description }}
                  className="short-description"
                />
              ) : (
                <div className="no-description">
                  No hay descripción disponible
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div className="toast-notification">
          <div className="toast-content">
            <div className="toast-icon">✅</div>
            <div className="toast-message">
              {toastMessage.split('\n').map((line, index) => (
                <div key={index} className="toast-line">{line}</div>
              ))}
            </div>
            <button className="toast-close" onClick={() => setShowToast(false)}>
              ×
            </button> 
          </div>
        </div>
      )}

      {/* ESTILOS CSS */}
   <style jsx>{`
  .product-page-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    font-family: "Noto Sans", sans-serif;
    background: #f7ede7;
    min-height: 100vh;
    box-sizing: border-box;
  }

  .back-button {
    background: #6c757d;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 17px;
    font-family: "Noto Sans", sans-serif;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .back-button:hover {
    background: #5a6268;
    transform: translateY(-1px);
  }

  .main-container {
    background: #f7ede7;
    padding: 40px;
    border-radius: 16px;
    border: 1px solid #f7ede7;
    margin-bottom: 40px;
    box-sizing: border-box;
  }

  .product-layout {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 50px;
    align-items: start;
  }

  .product-header {
    margin-bottom: 25px;
  }

  .product-title {
    font-size: 42px;
    font-weight: bold;
    font-family: Montserrat, sans-serif;
    color: #333333;
    margin: 0 0 12px 0;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: -0.5px;
    text-align: left;
  }

  .category-title {
    font-size: 32px;
    font-weight: bold;
    font-family: Montserrat, sans-serif;
    color: #e46c41;
    margin: 0;
    line-height: 1.3;
    text-align: left;
  }

  .short-description {
    line-height: 1.5;
    font-size: 17px;
    color: #333333;
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
    max-width: 80ch;
    word-wrap: break-word;
    overflow-wrap: break-word;
    text-align: left;
  }

  .short-description :global(*) {
    color: #333333 !important;
    text-align: left;
  }

  .short-description :global(p) {
    color: #333333 !important;
    margin-bottom: 12px;
    text-align: left;
  }

  .short-description :global(strong) {
    color: #333333 !important;
    font-weight: 600;
    text-align: left;
  }

  .short-description :global(em) {
    color: #333333 !important;
    text-align: left;
  }

  .no-description {
    padding: 15px;
    text-align: left;
    color: #333333;
    font-style: italic;
    background: #f8f9fa;
    border-radius: 6px;
    font-size: 17px;
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
    line-height: 1.5;
    max-width: 80ch;
    margin: 0;
  }

  .inline-attributes-section {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .attributes-row {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: flex-end;
  }

  .attribute-column {
    flex: 1;
    min-width: 200px;
  }

  .attribute-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333333;
    font-size: 17px;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    text-align: left;
  }

  .attribute-select {
    width: 100%;
    padding: 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 17px;
    background: white;
    cursor: pointer;
    transition: border-color 0.3s ease;
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
    line-height: 1.5;
    color: #333333;
    text-align: left;
  }

  .attribute-select:focus {
    border-color: #e46c41;
    outline: none;
  }

  .inline-purchase-section {
    margin-bottom: 25px;
    padding-bottom: 20px;
    border-bottom: 2px solid #f0f0f0;
  }

  .price-quantity-container {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    margin-bottom: 15px;
    gap: 20px;
  }

  .quantity-price-group {
    display: flex;
    align-items: flex-end;
    gap: 20px;
  }

  .quantity-section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .quantity-label {
    font-weight: 600;
    color: #333333;
    font-size: 17px;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    text-align: left;
    margin: 0;
    white-space: nowrap;
  }

  .quantity-input-simple {
    width: 80px;
    height: 40px;
    border: 2px solid #e0e0e0;
    border-radius: 6px;
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    color: #333333;
  }

  .quantity-input-simple:focus {
    border-color: #e46c41;
    outline: none;
  }

  .price-section {
    flex: 0 0 auto;
  }

  .price-container {
    text-align: right;
  }

  .current-price {
    color: #e46c41;
    font-weight: bold;
    font-size: 32px;
    display: block;
    margin-bottom: 5px;
    font-family: Montserrat, sans-serif;
    line-height: 1.2;
    white-space: nowrap;
  }

  .action-buttons-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }

  .tax-shipping-info {
    flex: 1;
    font-size: 14px;
    color: #666;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.4;
    text-align: left;
  }

  .action-buttons {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .add-to-cart-btn {
    flex: 0 0 auto;
    min-width: 140px;
    padding: 15px 20px;
    border: none;
    border-radius: 8px;
    font-size: 17px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    background: #e46c41;
    color: white;
  }

  .add-to-cart-btn:hover {
    background: white;
    color: #e46c41;
    border: 2px solid #e46c41;
    transform: translateY(-2px);
  }

  .add-to-cart-btn:disabled {
    background: #cccccc;
    cursor: not-allowed;
    transform: none;
  }

  .tiered-pricing-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border: 1px solid #e0e0e0;
    margin-bottom: 20px;
    max-width: 100%;
  }

  .table-header-row {
    background: #f7ede7;
    border-bottom: 2px solid #e0e0e0;
  }

  .table-header-quantity,
  .table-header-price {
    padding: 15px 12px;
    font-weight: bold;
    color: #e46c41;
    font-size: 12.2px;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    text-align: center;
    border: none;
  }

  .table-header-quantity {
    border-right: 1px solid #e0e0e0;
  }

  .tiered-pricing-row {
    transition: background-color 0.3s ease;
    background: white;
    border-bottom: 1px solid #e0e0e0;
  }

  .tiered-pricing-row:last-child {
    border-bottom: none;
  }

  .tiered-pricing-row:hover {
    background: #f8f9fa;
  }

  .tiered-pricing-row.active-tier {
    background: #e46c41;
    color: white;
  }

  .tiered-pricing-row.active-tier .quantity-cell,
  .tiered-pricing-row.active-tier .price-cell {
    color: white;
    font-weight: 600;
  }

  .tiered-pricing-row td {
    padding: 12px;
    font-size: 17px;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    color: #555555;
    background: transparent;
    border-right: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  .tiered-pricing-row td:last-child {
    border-right: none;
  }

  .quantity-cell {
    font-weight: 500;
    color: #555555;
  }

  .price-cell {
    font-weight: 500;
    color: #555555;
  }

  .tiered-pricing-row.active-tier .quantity-cell,
  .tiered-pricing-row.active-tier .price-cell {
    color: white;
  }

  .product-media {
    position: sticky;
    top: 20px;
  }

  .image-section {
    margin-bottom: 25px;
  }

  .main-image {
    width: 100%;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.1);
    margin-bottom: 15px;
  }

  .image-thumbnails {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding: 10px 0;
  }

  .thumbnail {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    object-fit: cover;
  }

  .thumbnail:hover {
    border-color: #e46c41;
  }

  .thumbnail.active {
    border-color: #e46c41;
    box-shadow: 0 2px8px rgba(228, 108, 65, 0.3);
  }

  .image-placeholder {
    width: 100%;
    height: 300px;
    background: #f8f9fa;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 64px;
    color: #6c757d;
    margin-bottom: 25px;
  }

  .long-description {
    line-height: 1.5;
    font-size: 17px;
    color: #333333;
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
    word-wrap: break-word;
    overflow-wrap: break-word;
    text-align: left;
  }

  .long-description :global(*) {
    color: #333333 !important;
    text-align: left;
  }

  .long-description :global(p) {
    color: #333333 !important;
    margin-bottom: 12px;
    text-align: left;
  }

  .long-description :global(strong) {
    color: #333333 !important;
    font-weight: 600;
    text-align: left;
  }

  .long-description :global(em) {
    color: #333333 !important;
    text-align: left;
  }

  .toast-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    animation: slideInRight 0.3s ease;
  }

  .toast-content {
    background: #28a745;
    color: white;
    padding: 16px 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    display: flex;
    align-items: flex-start;
    gap: 12px;
    max-width: 400px;
    border-left: 4px solid #1e7e34;
  }

  .toast-icon {
    font-size: 20px;
    flex-shrink: 0;
  }

  .toast-message {
    flex: 1;
    font-size: 17px;
    line-height: 1.4;
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
  }

  .toast-line {
    margin-bottom: 4px;
  }

  .toast-line:last-child {
    margin-bottom: 0;
  }

  .toast-close {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 18px;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s ease;
  }

  .toast-close:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .loading-container, .error-container {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 16px;
    margin: 20px auto;
    max-width: 600px;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  }

  .loading-icon, .error-icon {
    font-size: 64px;
    margin-bottom: 20px;
  }

  .loading-title, .error-title {
    font-size: 32px;
    font-weight: bold;
    font-family: Montserrat, sans-serif;
    color: #333333;
    margin-bottom: 15px;
    line-height: 1.3;
  }

  .error-message {
    font-size: 17px;
    color: #666666;
    font-family: "Noto Sans", sans-serif;
    line-height: 1.5;
    margin-bottom: 25px;
  }

  .error-content {
    margin-top: 25px;
  }

  .error-button {
    background: #e46c41;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    font-size: 17px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: "Noto Sans", sans-serif;
    font-weight: 600;
    line-height: 1.5;
  }

  .error-button:hover {
    background: #d45a2e;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    .product-page-container {
      padding: 15px;
    }

    .main-container {
      padding: 20px;
      margin-bottom: 20px;
    }

    .product-layout {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .product-media {
      order: -1;
    }

    .product-title {
      font-size: 32px;
      text-align: left;
      margin-bottom: 8px;
    }

    .category-title {
      font-size: 24px;
      text-align: left;
      margin-bottom: 20px;
    }

    .attributes-row {
      flex-direction: column;
      gap: 15px;
    }

    .attribute-column {
      min-width: auto;
    }

    .attribute-label {
      text-align: left;
    }

    .price-quantity-container {
      justify-content: flex-start;
    }

    .quantity-price-group {
      width: 100%;
      justify-content: space-between;
    }

    .quantity-section {
      align-items: flex-start;
    }

    .price-container {
      text-align: right;
    }

    .action-buttons-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
    }

    .tax-shipping-info {
      text-align: left;
      margin-bottom: 0;
    }

    .action-buttons {
      justify-content: flex-start;
      width: 100%;
    }

    .pricing-and-contact-section {
      flex-direction: column;
    }

    

    .tiered-pricing-table {
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    .product-title {
      font-size: 28px;
    }

    .category-title {
      font-size: 20px;
    }

    .current-price {
      font-size: 28px;
    }

    .quantity-price-group {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
    }

    .price-container {
      text-align: left;
    }

    .action-buttons {
      flex-direction: column;
      width: 100%;
    }

    .add-to-cart-btn {
      min-width: auto;
      width: 100%;
    }

    .pricing-and-contact-section {
      flex-direction: column;
    }

 

    .tiered-pricing-table {
      width: 100%;
    }
  }

  .pricing-and-contact-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-top: 20px;
  }

  

   h3 {
    font-size: 20px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 15px;
    font-family: Montserrat, sans-serif;
    text-align: left;
  }

  .project-textarea {
    width: 90%;
    height: 80px; /* Altura reducida para evitar scroll */
    padding: 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 17px;
    margin-bottom: 10px;
    resize: none; /* Desactiva el redimensionamiento manual */
    font-family: "Noto Sans", sans-serif;
    color: #333333;
  }

  .input-field {
    width: 90%;
    padding: 12px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 17px;
    margin-bottom: 10px;
    font-family: "Noto Sans", sans-serif;
    color: #333333;
  }
.contact-form-section {
  flex: 0 0 45%;
  padding: 20px;
  border-radius: 12px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
  .send-button {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex; /* Cambiado a inline-flex para no ocupar todo el ancho */
  align-items: center;
  justify-content: center;
  font-family: "Noto Sans", sans-serif;
  line-height: 1.5;
  background: #e46c41;
  color: white;
  width: auto;
  margin-left: auto; /* Mueve el botón a la derecha */
}

  .send-button:hover {
  background: white;
  color: #e46c41;
  border: 2px solid #e46c41;
  transform: translateY(-2px);
}
`}</style>
    </div>
  );
};

export default ProductoPage;